import { useQuery } from 'react-query'
import { Project } from '@dc-shared-web/hooks/api/project'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import { fetchProjectsForMove } from '@dc-shared-web/hooks/api/project/fetchProjectsForMove'

const QUERY_KEY = ['ProjectsForMove']

export const useProjectsForMove = (currentTeamId: number) => {
  const apiClient = useAxiosContext()

  return useQuery<Project[], Error>(QUERY_KEY, () =>
    fetchProjectsForMove(apiClient, { currentTeamId })
  )
}
